import React, { Component } from "react";
import { Table } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { postSubmitApi } from "./actions";
import { prepareRender } from "./summaryConfig";
import { ConfirmTerms } from "./Components/LanguageComponent";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import { FixedWidth } from "../../../../CommonComponents/commonStyles";
import { GrantAgreementHeading, SectionMediumDivider, Block } from "./styles";
import { fetchAccountAdvisors } from "../../../../actions/globalActions";
import Step3Summary from "./Steps/EditAndReviewGrant/Step3Summary";
import ViewRecurSchedule from "../RecommendGrant/Component/ViewEditSchedules/Components/ViewRecurSchedule";
import Step1Summary from "../RecommendGrant/Component/ViewEditSchedules/Components/Step1Summary";
import Step2Summary from "../RecommendGrant/Component/ViewEditSchedules/Components/Step2Summary";
import PermissionToPublish from "../RecommendGrant/Component/ViewEditSchedules/Components/PermissionToPublish";
import { GrantGhostButton } from "../RecommendGrant/style";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import {
  ConfirmationNotes,
  ConfirmationRules,
  StyleLessButton
} from "./styles";
import PreviewLetters from "./Components/ReviewAndSubmit/Components/PreviewLetter/PreviewLetters";
import PagePrintButton from "../../../../CommonComponents/PrintButton/PagePrintButton";
import { milliToDate, recordError } from "../../../../utils/commonUtil";
import { viewGrantAgreementDerivedStates } from './Selectors/ViewGrantAgreementSelectors';

export class ViewGrantAgreements extends Component {

  getGrantAgreementApi() {
    const { grantAgreementId } = queryString.parse(this.props.location.search);
    const data = {
      method: "GET",
      page: "grantAgreements",
      url: `/donor-portal/api/grantAgreement/${
        getPrimaryAccount().userId
      }/findGrantAgreementByAccountIdAndGrantAgreementId?grantAgreementId=${grantAgreementId}`
    };
    this.props.getGrantAgreementData(data);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getGrantAgreementApi();
    this.props.fetchAdvisors({ accountId: getPrimaryAccount().userId });
  }

  componentDidUpdate(nextProps) {
    if (this.props.advisors !== nextProps.advisors) {
      this.setState({ advisors: nextProps.advisors });
    }
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "Grants",
        path: "/grants"
      },
      {
        routeName: "Grant Activity",
        path: "/grants/activity"
      },
      {
        routeName: "View Grant Agreement",
      }
    ];
  };

  goToPage = tab => {
    try {
      this.props.history.push({
        pathname: `/grants/activity`,
        state: { grantTab: tab }
      });
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    const {
      payments,
      startDate,
      noOfPayments,
      grantAgreementId,
      contact,
      purpose,
      grantAgreementAmount,
      recognition
    } = this.props;

    const printRef = React.createRef();
    if (!noOfPayments && !payments.length && !startDate && !contact && !purpose)
    return <Preloader />

    const {
      charityInfo,
      purposeRecognition,
      publishName,
      amountAllocation,
      scheduleData,
      codeValueMappingData
    } = prepareRender(this.props);

    let address =
      contact.addressLine1 +
      contact.addressLine2 +
      contact.addressLine3 +
      contact.state +
      contact.city +
      contact.zip;

    return (
      <FixedWidth>
        <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
        <div ref={printRef}>
          <GrantAgreementHeading>
            Grant Agreement Confirmation
          </GrantAgreementHeading>
          <SectionMediumDivider smallMarginTop smallMarginBottom />
          <ConfirmTerms />
          <SectionMediumDivider smallMarginTop smallMarginBottom />
          <Block flex fixEnds alignTop>
            <Block flex={2}>
              <Block>
                <ConfirmationRules>Grant Agreement ID:&nbsp;</ConfirmationRules>
                <ConfirmationNotes>{grantAgreementId}</ConfirmationNotes>
              </Block>
              <Block>
                <ConfirmationRules>Entered Date:&nbsp;</ConfirmationRules>
                <ConfirmationNotes lineHeight>
                  {milliToDate(startDate)}
                </ConfirmationNotes>
              </Block>
            </Block>
            <StyleLessButton>
              <PagePrintButton
                className="ml-auto"
                contentRef={() => printRef.current}
              />
            </StyleLessButton>
          </Block>

          <SectionMediumDivider />
          <Step1Summary
            charityInfo={charityInfo}
            purposeRecognition={purposeRecognition}
            codeValueMappingData={codeValueMappingData}
          />
          <SectionMediumDivider smallMarginTop smallMarginBottom />
          <PermissionToPublish publish={publishName} />
          <Block h={50} />
          <Step2Summary {...amountAllocation} />
          {this.props.scheduleType === "recurring" && (
            <>
              <SectionMediumDivider smallMarginTop />
              <ViewRecurSchedule
                title="Recurring Grant Schedule"
                scheduleData={scheduleData}
              />
            </>
          )}
          <SectionMediumDivider smallMarginBottom />
          <Step3Summary payments={payments} />
        </div>
        <SectionMediumDivider smallMarginBottom />
        {payments && payments.length && (
          <PreviewLetters
            id={"multipage"}
            selectedCharityName={contact.legalname}
            selectedCharityAddress={address}
            granteeOrgFirstName={contact.charityContactFirstName}
            granteeOrgLastName={contact.charityContactLastName}
            startDate={startDate}
            grantPurpose={purpose}
            grantAgreementAmount={grantAgreementAmount}
            grantRecognition={recognition}
            accountName={recognition.recognition}
            selectedCharityEin={contact.ein}
            codeValueMappingData={this.props.codeValueMappingData}
          />
        )}
        <SectionMediumDivider smallMarginBottom />
        <GrantGhostButton
          width={"auto"}
          onClick={() => this.goToPage('3')}
        >
          View all Grants Agreements
        </GrantGhostButton>
      </FixedWidth>
    );
  }
}

const mapStateToProps = state => ({
  ...viewGrantAgreementDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  getGrantAgreementData: data => dispatch(postSubmitApi(data)),
  fetchAdvisors: data => dispatch(fetchAccountAdvisors(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ViewGrantAgreements)
);
